/**
 * ONE SHAPE FOR EVERY MOBILE: +44 7967 703590.
 *
 * Ten people typing their own number produce ten formats — 07967703590,
 * 07967 703590, +447967703590, (07967) 703590 — and every one of them ends up
 * under somebody's name on every email they send. This takes any of those and
 * returns the house format: +44, the four, a space, the six.
 *
 * Anything that is NOT a UK number is returned exactly as typed. A colleague
 * with a foreign mobile should get their number printed, not reformatted into a
 * British one it is not.
 */
export function ukMobile(raw) {
  const s = String(raw == null ? '' : raw).trim();
  if (!s) return '';
  const digits = s.replace(/[\s()\-.]/g, '');
  let national = null;
  if (/^\+44\d{10}$/.test(digits)) national = digits.slice(3);
  else if (/^0044\d{10}$/.test(digits)) national = digits.slice(4);
  else if (/^44\d{10}$/.test(digits)) national = digits.slice(2);
  else if (/^0\d{10}$/.test(digits)) national = digits.slice(1);
  if (!national) return s;
  return `+44 ${national.slice(0, 4)} ${national.slice(4)}`;
}

